import { render, staticRenderFns } from "./Staff01.vue?vue&type=template&id=47a75267&"
import script from "./Staff01.vue?vue&type=script&lang=js&"
export * from "./Staff01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports